import React, { ReactNode } from 'react'
import { CustomButton, Modal, ModalContent, ModalFooter, ModalTitle, ModalWrapper } from './styles'
import { Icon } from '@dasa-health/alma-react'

type CustomModalProps = {
    showCloseButton?: boolean
    onClose?: () => void
    onClick: () => void
    open?: boolean
    title?: string
    children?: ReactNode
    buttonData: {
        href: string
        icon?: React.ReactElement
        taget?: string
    }
}

export const CustomModalFeedbackUnico = ({
    onClose,
    onClick,
    open,
    title,
    showCloseButton = true,
    children,
    buttonData,
}: CustomModalProps) => (
    <Modal fullMobile={true} onClose={onClose} open={open}>
        <ModalWrapper>
            {title && <ModalTitle>{title}</ModalTitle>}
            {children && <ModalContent>{children}</ModalContent>}
            {showCloseButton && (
                <ModalFooter>
                    <CustomButton
                        data-current-service="Reconhecimento Facial"
                        data-item-position="Modal Falha no reconhecimento facial"
                        data-item-text="Falar com atendente"
                        href={buttonData?.href}
                        onClick={onClick}
                        target={buttonData?.taget}
                        title="Falar com atendente"
                        type="button"
                    >
                        {buttonData?.icon && <Icon size="lg">{buttonData?.icon}</Icon>}
                        Falar com atendente
                    </CustomButton>
                </ModalFooter>
            )}
        </ModalWrapper>
    </Modal>
)
